import { FC, SVGProps } from 'react';

const CloseV2: FC<SVGProps<SVGSVGElement>> = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.3594 14.8906C15.5 15.0312 15.5 15.2656 15.3594 15.4062C15.2188 15.5469 14.9844 15.5469 14.8438 15.4062L8 8.5625L1.10938 15.4062C0.96875 15.5469 0.734375 15.5469 0.59375 15.4062C0.453125 15.2656 0.453125 15.0312 0.59375 14.8906L7.4375 8L0.59375 1.15625C0.453125 1.01562 0.453125 0.78125 0.59375 0.640625C0.734375 0.5 0.96875 0.5 1.10938 0.640625L8 7.48438L14.8438 0.640625C14.9844 0.5 15.2188 0.5 15.3594 0.640625C15.5 0.78125 15.5 1.01562 15.3594 1.15625L8.51562 8L15.3594 14.8906Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CloseV2;
